import React from 'react';
import PropTypes from 'prop-types';

import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import i18n from 'i18next';

import { Avatar } from 'uikit/avatars';
import { Typo } from 'uikit/content';
import { Button } from 'uikit/buttons';

import styles from '../styles/selectedUserChip.module.scss';

const SelectedUserChip = ({ handleRemoveSelected = () => {}, selectedItem = {} }) => {
  const avatar = selectedItem.avatar_path || selectedItem.avatar_url;
  const isUser = selectedItem.type === 'user';
  const hasAvatar = Boolean(avatar) || isUser;
  const name = selectedItem.name || `${selectedItem.first_name} ${selectedItem.last_name}`;

  const getSecondaryText = () => {
    if (isUser) return selectedItem.code;

    const { metadata } = selectedItem;
    const eligibleMembers = metadata?.number_of_eligible_members;

    return eligibleMembers
      ? i18n.t('eligible-members-count-total', { countTotal: eligibleMembers })
      : i18n.t('member-count', { count: metadata?.number_of_members });
  };

  return (
    <li className={styles.element}>
      <div className={styles.inner}>
        {hasAvatar && <Avatar ariaHidden avatar={avatar} name={name} />}
        <div className={styles.text}>
          <Typo noWrap title={name} variant="s01" weight="medium">
            {name}
          </Typo>
          <Typo color="secondary" noWrap variant="s01">
            {getSecondaryText()}
          </Typo>
        </div>
      </div>
      <Button
        ariaLabel={i18n.t('remove')}
        icon={<CloseOutlinedIcon />}
        onClick={() => handleRemoveSelected(selectedItem.id)}
        size="xsmall"
        variant="ghost"
      />
    </li>
  );
};

SelectedUserChip.propTypes = {
  handleRemoveSelected: PropTypes.func,
  selectedItem: PropTypes.shape({
    avatar_path: PropTypes.string,
    avatar_url: PropTypes.string,
    code: PropTypes.string,
    first_name: PropTypes.string,
    id: PropTypes.number,
    last_name: PropTypes.string,
    metadata: PropTypes.shape({
      number_of_eligible_members: PropTypes.string,
      number_of_members: PropTypes.number,
    }),
    name: PropTypes.string,
    type: PropTypes.oneOf(['group', 'user']),
  }),
};

export default SelectedUserChip;
